module.exports = __webpack_public_path__ + "media/images/lp_seiho/sec05_ico_01-e468be9d090c576f95f79d044f7440a9.png";